import { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { filtersData } from '../constants/filtersData';
import { createDateDefaultValue } from '../constants/common';
import { filterNames } from '../constants/filterNames';

const createDateFilter = filtersData[filterNames.createDate];

const useResetFilter = () => {
  const history = useHistory();

  const handleResetFilter = useCallback(() => {
    const searchParams = new URLSearchParams(history.location.search);

    const keys = Array.from(searchParams.keys());

    keys.forEach((key) => {
      searchParams.delete(key);
    });

    searchParams.set(
      createDateFilter.name,
      createDateFilter.serialize(createDateDefaultValue)
    );

    history.push({ search: searchParams.toString() });
  }, [history.location.search]);

  return handleResetFilter;
};

export default useResetFilter;
